// extracted by mini-css-extract-plugin
export default {"listWrapper":"styles_listWrapper__dhGlY","item":"styles_item__MrJCM"};